import React from 'react';
import cn from 'classnames';

import styles from './circleButton.css';

function CircleButton({ handler, isActive }) {
	const className = cn(styles.button, {
		[styles.isActive]: isActive 
	});

	return (
		<button onClick={handler} className={className}></button>
	);
}

export default CircleButton;


// WEBPACK FOOTER //
// ./src/components/CircleButton/CircleButton.js